import PropTypes from 'prop-types';
import React from 'react';
import { ApolloProvider } from 'react-apollo';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import { ThemeProvider } from '@zendeskgarden/react-theming';

import routes from './routes';

const theme = {
  main: 'main',
};

const Root = ({ store, history, onUpdate, client }) => (
  <ThemeProvider theme={theme}>
    <ApolloProvider store={store} client={client}>
      <Provider store={store}>
        <Router onUpdate={onUpdate} history={history} routes={routes} />
      </Provider>
    </ApolloProvider>
  </ThemeProvider>
);

Root.propTypes = {
  store: PropTypes.object.isRequired,
};

export default Root;



// WEBPACK FOOTER //
// ./src/views/Root.js